import { TiOpportunityView } from '@elva/ui';
import { useNavigate } from 'react-router-dom';

/**
 * Treatment Intelligence — Opportunity tab (amendment 27 §3). The default landing
 * at /treatment-intelligence. Every *Start a campaign →* opens the builder with a
 * description already written; it travels as `?desc=`.
 */
export function TiOpportunityPage() {
  const navigate = useNavigate();

  const startCampaign = (description: string) => {
    void navigate(`/treatment-intelligence/campaigns/new?desc=${encodeURIComponent(description)}`);
  };

  return (
    <TiOpportunityView
      onSelectTab={(tab) => {
        if (tab === 'campaigns') void navigate('/treatment-intelligence/campaigns');
      }}
      onOpenSettings={() => { void navigate('/settings/ai/treatment-coordinator'); }}
      onNewCampaign={() => { void navigate('/treatment-intelligence/campaigns/new'); }}
      onOpenCalls={() => { void navigate('/calls?type=treatment'); }}
      onStartCampaign={startCampaign}
    />
  );
}
